export default "__VITE_ASSET__iFxXXjeC__"